/**
 * @generated SignedSource<<138335bfda1b666fafd0f55e9649250d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type useInitializeBookingWizardNode$data = {
  readonly agenda?: {
    readonly date: string;
    readonly facility: {
      readonly club: {
        readonly supportsPrivate: boolean;
      } | null | undefined;
      readonly memberHoldDeadlineHours: number | null | undefined;
      readonly memberHoldEnabled: boolean;
      readonly type: FacilityType;
    };
  };
  readonly course?: {
    readonly courseLayouts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly code: string;
          readonly holeCount: HoleCount;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly defaultBookingDurationMins: number;
    readonly defaultCourseLayout: {
      readonly code: string;
      readonly holeCount: HoleCount;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly id: string;
    readonly name: string;
  };
  readonly currentDefaultBookingRate?: ReadonlyArray<{
    readonly rate: {
      readonly id: string;
    };
  } | null | undefined> | null | undefined;
  readonly currentDefaultRate?: {
    readonly rate: {
      readonly id: string;
    };
  } | null | undefined;
  readonly id?: string;
  readonly permittedCourseLayouts?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly code: string;
        readonly holeCount: HoleCount;
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly requirePlayerCounts?: boolean;
  readonly standardCapacity?: number;
  readonly time?: string;
  readonly usedCapacity?: number;
  readonly " $fragmentSpreads": FragmentRefs<"useValidDurationsNode">;
  readonly " $fragmentType": "useInitializeBookingWizardNode";
};
export type useInitializeBookingWizardNode$key = {
  readonly " $data"?: useInitializeBookingWizardNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeBookingWizardNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "membershipTypeId",
    "variableName": "membershipTypeId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "CUSTOMER"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "holeCount",
    "storageKey": null
  },
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CourseLayoutEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CourseLayout",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeBookingWizardNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useValidDurationsNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        },
        {
          "alias": "standardCapacity",
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usedCapacity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePlayerCounts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberHoldEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberHoldDeadlineHours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "currentDefaultBookingRate",
          "args": (v1/*: any*/),
          "concreteType": "SlotRate",
          "kind": "LinkedField",
          "name": "bookingRates",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": "currentDefaultRate",
          "args": (v1/*: any*/),
          "concreteType": "SlotRate",
          "kind": "LinkedField",
          "name": "playerRateForMembershipType",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultBookingDurationMins",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseLayout",
              "kind": "LinkedField",
              "name": "defaultCourseLayout",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseLayoutConnection",
              "kind": "LinkedField",
              "name": "courseLayouts",
              "plural": false,
              "selections": (v5/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "memberVisible",
              "value": true
            }
          ],
          "concreteType": "CourseLayoutConnection",
          "kind": "LinkedField",
          "name": "permittedCourseLayouts",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": "permittedCourseLayouts(memberVisible:true)"
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "d416cb2af99299a40b8ba6adcb112f92";

export default node;
